/**
 * Convert a dotted path to a population square bracket notation
 *
 * @param path - The dotted path to convert
 * @returns - The population square bracket notation
 *
 * @example
 * // Returns '[tireSize][tire]'
 * dottedPathToPopulation('tireSize.tire')
 */
export default function dottedPathToPopulation(path: string) {
  const trimmedPath = path.trim();
  if (trimmedPath.length === 0) return '';

  return trimmedPath
    .split('.')
    .filter((segment) => segment.trim().length > 0)
    .map((item) => `[${item}]`)
    .join('');
}
